import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "md:m-4 flex md:rounded shadow bg-white overflow-hidden"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:block py-4 px-6 bg-gray-200 text-gray-900 font-bold" }, "Search", -1)
const _hoisted_3 = { class: "py-2 px-3 flex-grow" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "bg-green-400 font-bold hover:bg-green-500 text-white px-1 md:px-4" }, " Search ", -1)
const _hoisted_6 = {
  key: 1,
  class: "p-4 my-3 w-full flex justify-center btn-group pt-6 flex-wrap space-x-2"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "h-32 rounded-md shadow bg-gray-700 text-white p-3 flex items-center justify-center" }
const _hoisted_9 = ["src", "alt", "title"]
const _hoisted_10 = {
  key: 1,
  class: "text-2xl break-words text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_pop_transition = _resolveComponent("b-pop-transition")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    show: _ctx.$apollo.loading,
    class: "h-full"
  }, {
    default: _withCtx(() => [
      (!_ctx.selectedLetter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                type: "text",
                name: "q",
                placeholder: "Search...",
                class: "w-full border-transparent bg-transparent focus:ring-gray-100 focus:border-gray-200 m-0 p-2"
              }, null, 512), [
                [_vModelText, _ctx.query]
              ])
            ]),
            (!_ctx.query)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_n_select, {
                    id: "sortBy",
                    modelValue: _ctx.sort,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sort) = $event)),
                    name: "sortBy",
                    "root-class": "bg-gray-200 flex items-center h-full px-1 md:px-3 relative",
                    "select-class": "border-transparent bg-transparent focus:ring-transparent focus:border-transparent focus:bg-transparent text-gray-500 sm:text-sm",
                    options: _ctx.selectOptions
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (!_ctx.query)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.letters, (letter) => {
              return (_openBlock(), _createBlock(_component_n_button, {
                key: `letter-${letter}`,
                type: "info",
                ghost: _ctx.selectedLetter !== letter,
                class: "w-12",
                onClick: ($event: any) => (_ctx.setLetter(letter))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(letter), 1)
                ]),
                _: 2
              }, 1032, ["ghost", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.sites)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_b_pop_transition, { class: "p-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites.collection, (site) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: site.id,
                    to: `/sites/${site.short_name}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (site.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: site.logo.url,
                              alt: site.name,
                              title: site.name,
                              class: "max-h-24 object-contain"
                            }, null, 8, _hoisted_9))
                          : (_openBlock(), _createElementBlock("h1", _hoisted_10, _toDisplayString(site.name), 1))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_b_pagination, {
        meta: _ctx.paginationMeta,
        onChange: _ctx.onPaginate
      }, null, 8, ["meta", "onChange"])
    ]),
    _: 1
  }, 8, ["show"]))
}